import React, {Component}   from 'react';

class ReferenceRequestComplete extends Component {
    render() {
        return (
            <div>
                <question-row class="header-row">
                    <h1>Referee Details Successfully Submitted</h1>
                    <p>Thank you for submitting your details.</p>
                </question-row>
            </div>
        );
    }
}

export default ReferenceRequestComplete;


// WEBPACK FOOTER //
// ./src/components/Screens/ReferenceRequest/Complete.js